import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl } from '@ngneat/reactive-forms';

@Component({
  selector: 'app-dialog-add',
  templateUrl: './dialog-add.component.html',
  styleUrls: ['./dialog-add.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogAddComponent {
  indexControl: FormControl<boolean> = new FormControl();
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      content: {
        h1?: string;
        p?: string;
        button?: string;
      };
    },
    private readonly dialogRef: MatDialogRef<DialogAddComponent>
  ) {}

  sendIndex() {
    this.indexControl.setValue(true);
    this.dialogRef.close(this.indexControl.value);
  }
}
